import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { browserTimezone, tzLabel } from "@/lib/timezones";

/** Barns that never picked a time zone get the trainer's browser zone saved once,
 *  with a notice — reminders would otherwise assume Eastern. */
export function useBarnTimezoneAutoDetect(ws, user) {
  const qc = useQueryClient();
  const done = useRef(false);
  useEffect(() => {
    if (done.current || !ws || !user || ws.timezone) return;
    if (!(user.role === "owner" || user.role === "admin")) return;
    const tz = browserTimezone();
    if (!tz) return;
    done.current = true;
    api.put("/workspace", { timezone: tz })
      .then(() => {
        qc.invalidateQueries({ queryKey: ["workspace"] });
        toast.message(`We set your barn's time zone to ${tzLabel(tz)}`, {
          description: "Task reminders and med-time texts use it. Change it any time in Settings → Barn profile.",
          duration: 10000,
        });
      })
      .catch(() => { done.current = false; });
  }, [ws, user, qc]);
}
